import math from '@/modules/filters/math'
import text from '@/modules/filters/text'


export default {
    ...math,
    ...text
}